module.exports = __webpack_public_path__ + "img/storm.f698e083.png";